//------------------------------------------------------------------------------
// 申込情報一覧
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PoleItem from '@/utils/pole-item';

/**
 * 項目名と項目値の一覧.
 */
export function LabelValueList({
  dataList,
  valueWidth = 'auto',
}) {
  return dataList.map((data, idx) => {
    const last = (idx == dataList.length - 1);
    return (

      // 項目名と項目値の一覧
      <Stack key={'item-' + idx}
        direction="row"
        sx={{
          border: 1,
          borderBottom: last ? 1: 0,
          borderColor: 'grey.400',
        }}
      >
        {/* 項目名 */}
        <Typography variant="subtitle2" sx={SX_LABEL_STYLE}>
          {data.label}
        </Typography>

        {/* 項目値 */}
        <Typography variant='body2'
          sx={{
           ...SX_VALUE_STYLE,
           minWidth: valueWidth,
         }}
        >
          {data.value}
        </Typography>
      </Stack>
    );
  });
}

// プロパティ
LabelValueList.propTypes = {
  dataList: PropTypes.array.isRequired,
};

// 項目名スタイル
const SX_LABEL_STYLE = {
  px: 1, py: 0.3,

  // 固定幅
  width: '10rem',
  flexShrink: 0,

  // 文字色/背景色
  color: 'info.contrastText',
  bgcolor: 'info.dark',
};

// 項目値スタイル
const SX_VALUE_STYLE = {
  px: 1, py: 0.3,

  // 可変幅
  flex: 1,

  // 折り返し表示なし
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}

/**
 * 申込情報一覧
 */
export default function OrderInformations({
  orderNo,
  orderInfo,
}) {
  // 代表電柱
  const orderPole = new PoleItem({
    areaCode: orderInfo.kojiAreaCode,
    areaName: orderInfo.kojiAreaName,
    lineCode: orderInfo.kojiLineCode,
    lineName: orderInfo.kojiLineName,
    poleNo: orderInfo.kojiPoleNo,
    latitude: orderInfo.kojiLatitude,
    longitude: orderInfo.kojiLongitude,
  });
  const areaName = orderPole.areaName || '';
  const poleText = orderPole.longText();

  // 申込情報(左)
  const dataL = [
    { label: '申込番号',   value: orderNo.toString() },
    { label: '共架事業者', value: orderInfo.zigyosyaName },
    { label: '工事件名',   value: orderInfo.kojiKenmei },
    { label: '申込日',     value: orderInfo.orderDate },
    { label: '代表電柱',   value: areaName + ' ' + poleText },
  ];

  // 申込情報(右)
  const dataR = [
    { label: '工事場所 都道府県', value: orderInfo.kojiTodofuken },
    { label: '工事場所 市区町村', value: orderInfo.kojiSikutyoson },
    { label: '工事場所 大字通称', value: orderInfo.kojiOazatusyo },
    { label: '工事場所 字丁目',   value: orderInfo.kojiAzatyome },
    { label: '工事場所 ビル名等', value: orderInfo.kojiBirumei },
  ];

  //
  // 描画
  //
  return (
    // 申込情報
    <Grid container columnSpacing={2} sx={{ mt: 2 }}>

      {/* 申込情報(左) */}
      <Grid item sm={12} md={6} sx={{ flex: 1 }}>
        <LabelValueList dataList={dataL} />
      </Grid>

      {/* 申込情報(右) */}
      <Grid item sm={12} md={6} sx={{ flex: 1 }}>
        <LabelValueList dataList={dataR} />
      </Grid>
    </Grid>
  );
}

// プロパティ
OrderInformations.propTypes = {
  orderNo:   PropTypes.object.isRequired,
  orderInfo: PropTypes.object.isRequired,
};
